import { RestrictionOperator } from '@iota/iota-management-portal-v4-client';

export const RestrictionOperators = [
    RestrictionOperator.EQ,
    RestrictionOperator.GE,
    RestrictionOperator.GT,
    RestrictionOperator.IN,
    RestrictionOperator.LE,
    RestrictionOperator.LT
];

export const RestrictionOperatorDescriptions = new Map([
    [RestrictionOperator.EQ, '='],
    [RestrictionOperator.GE, '>='],
    [RestrictionOperator.GT, '>'],
    [RestrictionOperator.IN, 'IN'],
    [RestrictionOperator.LE, '<='],
    [RestrictionOperator.LT, '<']
]);
